import {VodDownloadDataVo} from '../../common/shared/api/gateway/viewer/VodDownloadDataVo.interface';
import {DrmServerType, VodDownloadData} from '../generated/types';
import {createDrmType} from './DrmType';

export function createVodDownloadData({
  packages,
}: VodDownloadDataVo): VodDownloadData | undefined {
  if (!packages || packages.length === 0) {
    return undefined;
  }

  const vodPackage = packages[0];
  return {
    contentPackId: vodPackage.content_pack_id,
    drmType: createDrmType(vodPackage.drm_type),
    duration: vodPackage.duration,
    endpointUrl: vodPackage.endpoint_url,
    width: vodPackage.width,
    height: vodPackage.height,
    drmServerType:
      vodPackage.drm_server_type === 5 ? DrmServerType.Ini : DrmServerType.Page, //  default: 4
  };
}
